import { Wrapper } from "@Src/layout/Wrapper";
import { ApplicationsPublicEdit } from "@Src/resources/applications_public/ApplicationsPublicEdit";
import { resourceName } from "@Src/resources/applications_public/name";
import type { Resource } from "@Src/resources/resources_config";
import DynamicFormIcon from "@mui/icons-material/DynamicForm";

const resource: Resource = {
	edit: Wrapper(resourceName.name, "edit", ApplicationsPublicEdit),
	icon: DynamicFormIcon,
	name: resourceName.name,
	path: `/${resourceName.name}`,
	apiPath: "applications_public/applications_public",
};

export default resource;
